var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "presentation-training-teaching-meeting-discussion_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,18c0,3.309,2.691,6,6,6s6-2.691,6-6s-2.691-6-6-6S10,14.691,10,18z M20,18c0,2.206-1.794,4-4,4s-4-1.794-4-4 s1.794-4,4-4S20,15.794,20,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.707,28.707l7-7c0.391-0.391,0.391-1.023,0-1.414l-3-3c-0.37-0.37-0.962-0.392-1.358-0.052l-6.884,5.9L19.795,26H8 c-0.289,0-0.562,0.124-0.752,0.342l-7,8c-0.234,0.267-0.309,0.638-0.196,0.975l3,9c0.092,0.274,0.298,0.496,0.566,0.607 c0.268,0.109,0.569,0.1,0.83-0.029l4-2C8.79,42.724,9,42.381,9,42.019V59c0,2.757,2.243,5,5,5h8c0.552,0,1-0.447,1-1V32.618 l7.447-3.724C30.544,28.847,30.631,28.783,30.707,28.707z M9,41.98c0-0.118-0.025-0.236-0.071-0.352L7.145,37.17L9,34.851V41.98z  M21.553,31.105C21.214,31.275,21,31.621,21,32v30h-4V46c0-0.553-0.448-1-1-1s-1,0.447-1,1v16h-1c-1.654,0-3-1.346-3-3V32 c0-0.425-0.268-0.803-0.669-0.943c-0.4-0.141-0.847-0.013-1.112,0.318l-4,5c-0.225,0.281-0.281,0.662-0.148,0.996l1.659,4.146 L4.584,42.59L2.13,35.228L8.454,28H20c0.135,0,0.27-0.027,0.394-0.081l7-3c0.093-0.04,0.18-0.094,0.257-0.16l6.297-5.396 L35.586,21l-6.178,6.178L21.553,31.105z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14,32 15,32 15,40 17,40 17,32 18,32 18,30 14,30  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,50c0-3.309-2.691-6-6-6c-2.086,0-3.924,1.071-5,2.69C51.924,45.07,50.086,44,48,44s-3.924,1.071-5,2.69 C41.924,45.07,40.086,44,38,44c-3.309,0-6,2.691-6,6c0,2.086,1.071,3.924,2.69,5C33.07,56.076,32,57.914,32,60v4h2v-4 c0-2.206,1.794-4,4-4s4,1.794,4,4v4h2v-4c0-2.206,1.794-4,4-4s4,1.794,4,4v4h2v-4c0-2.206,1.794-4,4-4s4,1.794,4,4v4h2v-4 c0-2.086-1.071-3.924-2.69-5C62.929,53.924,64,52.086,64,50z M48,46c2.206,0,4,1.794,4,4s-1.794,4-4,4s-4-1.794-4-4 S45.795,46,48,46z M34,50c0-2.206,1.794-4,4-4s4,1.794,4,4s-1.794,4-4,4S34,52.206,34,50z M43,56.69 c-0.445-0.67-1.02-1.245-1.69-1.69c0.67-0.445,1.245-1.02,1.69-1.69c0.445,0.67,1.02,1.245,1.69,1.69 C44.02,55.445,43.445,56.02,43,56.69z M53,56.69c-0.445-0.67-1.02-1.245-1.69-1.69c0.67-0.445,1.245-1.02,1.69-1.69 c0.445,0.67,1.02,1.245,1.69,1.69C54.02,55.445,53.445,56.02,53,56.69z M58,54c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4 S60.206,54,58,54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,0H26c-0.552,0-1,0.447-1,1v19h2V2h35v27c0,1.654-1.346,3-3,3H28v2h31c2.757,0,5-2.243,5-5V1C64,0.447,63.552,0,63,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,5H32c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h10c0.552,0,1-0.447,1-1V9h3v1c0,0.553,0.448,1,1,1h4v3h-4 c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h4v3h-4c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h10c0.552,0,1-0.447,1-1v-4 c0-0.553-0.448-1-1-1h-4v-3h4c0.552,0,1-0.447,1-1v-4c0-0.553-0.448-1-1-1h-4v-3h4c0.552,0,1-0.447,1-1V6c0-0.553-0.448-1-1-1H47 c-0.552,0-1,0.447-1,1v1h-3V6C43,5.447,42.552,5,42,5z M41,9h-8V7h8V9z M56,27h-8v-2h8V27z M56,18h-8v-2h8V18z M48,7h8v2h-8V7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 13,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 17,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 25,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,10h0.5l2.7,3.6C7.393,13.856,7.691,14,8,14c0.105,0,0.212-0.017,0.316-0.052C8.725,13.812,9,13.431,9,13v-3h6 c1.654,0,3-1.346,3-3V3c0-1.654-1.346-3-3-3H4C2.346,0,1,1.346,1,3v4C1,8.654,2.346,10,4,10z M3,3c0-0.552,0.449-1,1-1h11 c0.551,0,1,0.448,1,1v4c0,0.552-0.449,1-1,1H8C7.448,8,7,8.447,7,9v1L5.8,8.4C5.611,8.148,5.315,8,5,8H4C3.449,8,3,7.552,3,7V3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_21_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/Presentation.2303b6bafc6d2f47271c88397a1d4cde.svg";
export { ForwardRef as ReactComponent };